export const eye = () => (
  <path
    d="M12 4C5 4 1 12 1 12s4 8 11 8 11-8 11-8-4-8-11-8zm0 0a6 6 0 100 12 6 6 0 000-12zM2.697 9.389L1 8m20.302 1.389L23 8M5.521 6.472L4 4m14.482 2.467L20 4m-10.451.337L9 1.5m5.451 2.836L15 1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
